export enum SortingOptions {
  DEFAULT = 'DEFAULT',
  ALPHA_ASC = 'ALPHA_ASC',
  ALPHA_DESC = 'ALPHA_DESC'
}
